import React from 'react'
import { Card, Button, Typography, Space } from 'antd'
import { GoogleOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

function LoginPage() {
  const handleGoogleLogin = () => {
    window.location.href = '/accounts/google/login/'
  }

  const handleDevLogin = async () => {
    try {
      const response = await fetch('/api/v1/dev-login/', {
        method: 'POST',
        credentials: 'include',
      })
      
      if (response.ok) {
        // Reload the page to trigger auth check
        window.location.reload()
      } else {
        console.error('Dev login failed')
      }
    } catch (error) {
      console.error('Dev login error:', error)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f5f5f5',
    }}>
      <Card
        style={{
          width: '100%',
          maxWidth: 400,
          padding: '32px',
        }}
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div style={{ textAlign: 'center' }}>
            <Title level={2}>Lead Generation Console</Title>
            <Text type="secondary">
              Sign in with your Prime Numbers account
            </Text>
          </div>

          <Card
            style={{
              backgroundColor: '#f5f5f5',
              textAlign: 'center',
            }}
          >
            <Text type="secondary">
              Access restricted to @primenumbers.in email addresses
            </Text>
          </Card>

          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Button
              type="primary"
              size="large"
              block
              icon={<GoogleOutlined />}
              onClick={handleGoogleLogin}
              style={{
                backgroundColor: '#4285f4',
                borderColor: '#4285f4',
                height: '48px',
              }}
            >
              Sign in with Google
            </Button>

            <Button
              size="large"
              block
              onClick={handleDevLogin}
              style={{
                height: '48px',
              }}
            >
              Development Login (Test User)
            </Button>
          </Space>

          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <Text type="secondary" style={{ fontSize: '12px' }}>
              By signing in, you agree to the terms of service
            </Text>
          </div>
        </Space>
      </Card>
    </div>
  )
}

export default LoginPage